import React from "react";
import { Route, Navigate } from "react-router-dom";
import ProtectedRoute from "shared/components/routing/ProtectedRoute";
import { MobileLoginPage, MobileSignupPage } from "features/auth";
import { MobilePairHeadsetPage } from "features/device";
import { MobileHome } from "features/catalog";
import { MobileProfile } from "features/account";
import { MobileOrderHistoryPage } from "features/orders";
import { ROUTE_PATHS } from "app/config/routePaths";

type MobileRoutesProps = {
  isMobileDevice: boolean;
};

/**
 * `/mobile/*` routes. On non-mobile devices each one redirects back to its
 * desktop equivalent, preserving the original behavior in `App.tsx`.
 */
export const mobileRoutes = ({
  isMobileDevice,
}: MobileRoutesProps): React.ReactElement => (
  <>
    <Route
      path={ROUTE_PATHS.mobileLogin}
      element={
        isMobileDevice ? <MobileLoginPage /> : <Navigate to={ROUTE_PATHS.login} />
      }
    />
    <Route
      path={ROUTE_PATHS.mobileSignup}
      element={
        isMobileDevice ? <MobileSignupPage /> : <Navigate to={ROUTE_PATHS.signup} />
      }
    />
    <Route
      path={ROUTE_PATHS.mobile}
      element={<Navigate to={ROUTE_PATHS.mobilePairHeadset} />}
    />
    <Route
      path={ROUTE_PATHS.mobileHome}
      element={
        isMobileDevice ? (
          <ProtectedRoute>
            <MobileHome />
          </ProtectedRoute>
        ) : (
          <Navigate to={ROUTE_PATHS.home} replace />
        )
      }
    />
    <Route
      path={ROUTE_PATHS.mobilePairHeadset}
      element={
        isMobileDevice ? (
          <ProtectedRoute>
            <MobilePairHeadsetPage />
          </ProtectedRoute>
        ) : (
          <Navigate to={ROUTE_PATHS.homePairHeadset} />
        )
      }
    />
    <Route
      path={ROUTE_PATHS.mobileProfile}
      element={
        isMobileDevice ? (
          <ProtectedRoute>
            <MobileProfile />
          </ProtectedRoute>
        ) : (
          <Navigate to={ROUTE_PATHS.homeProfile} />
        )
      }
    />
    <Route
      path={ROUTE_PATHS.mobileOrderHistory}
      element={
        isMobileDevice ? (
          <ProtectedRoute>
            <MobileOrderHistoryPage />
          </ProtectedRoute>
        ) : (
          <Navigate to={ROUTE_PATHS.homeOrderHistory} />
        )
      }
    />
  </>
);

export default mobileRoutes;
